export default "__VITE_ASSET__B$xksw4$__"